// Side-effect barrel for the legacy admin subtree (WEB-8048). root.jsx creates the
// ReactTemplates.admin namespace; the rest populate its keys at module eval. Loaded once by
// ReactTemplatesShim at the React entry (root first). Order mirrors the old legacy-react.js.
//
// Every module is listed even though 26 of the keys are now imported directly by their single
// consumer: several subtree files still reach for siblings through the global (tableTokens,
// triggerCriteria, importUploader, notFound, script), so the namespace must stay fully populated.
// Not listed: components/HideTabs (imported relatively by pages/profile, loads with it) and
// pages/documentTemplates.test (a test).
import './root';
import './components/triggerCriteria';
import './components/appPreview';
import './sidebar';
import './pages/dashboard';
import './pages/fields';
import './pages/notFound';
import './pages/profile';
import './pages/2fa';
import './pages/activityTypes';
import './pages/scripts';
import './pages/editScript';
import './pages/integrations';
import './pages/udos';
import './pages/editIntegration';
import './pages/stages';
import './pages/currencies';
import './pages/mailSettings';
import './pages/visitSettings';
import './pages/marketRejectlist';
import './pages/accountProfile';
import './pages/usersAndRoles';
import './pages/triggers';
import './pages/editTrigger';
import './pages/documentTemplates';
import './pages/activityQuota';
import './pages/salesQuota';
import './pages/genericQuota';
import './components/quotaInput';
import './pages/deleteLog';
import './pages/imports';
import './pages/editAutomation';
import './components/tableTokens';
import './pages/optIns';
import './pages/optInModal';
import './pages/category';
import './components/importUploader';
import './standardIntegrations/fields';
